export default __webpack_public_path__ + "static/media/BGL_ProductTeam.0de17b11.png";